<template>
    <div id="edit-brand-page" class="dashboard-view">
        <div class="container">
            <section class="content">
                <h1>Edit Brand</h1>
                <template v-if="loaded">
                    <BrandForm :formData="brandObject" submitText="Update" @formSubmitted="updateBrand" />
                </template>
            </section>
        </div>
    </div>
</template>

<script>
import BrandForm from '@/components/forms/BrandForm.vue'
const apiBase = process.env.VUE_APP_API_BASE
import axios from 'axios'

export default {
    name: 'BrandsEdit',
    components: {
        BrandForm
    },
    data: function() {
        return {
            brandId: this.$route.params.id,
            brandObject: null,
            loaded: false
        }
    },
    created() {
        axios.get(apiBase + '/brands/' + this.brandId)
                .then(response => {
                    this.brandObject = response.data.data
                    this.loaded = true
                })
                .catch(error => {
                    alert('Could not load brand!')
                    console.log(error)
                })
    },
    methods: {
        updateBrand(data) {
            axios.put(apiBase + '/brands/' + this.brandId, data)
                  .then(response => {
                      console.log(response)
                      alert('Brand updated successfully')
                      this.$router.push('/brands')
                  })
                  .catch(error => {
                      alert('Error occurred!')
                      console.log(error)
                  })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
